var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"rankingTable__header"},[_vm._v(_vm._s(_vm.$t('rankingHeaderAll')))]),_vm._l((_vm.results),function(result){return _c('ranking-cell',{key:result.name,attrs:{"result":result}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }